import * as endpoints from './APIEndpoints';
import {appStore} from './AppStore';
import {action, observable} from 'mobx';
import {message,Icon} from 'antd';
import {booleanAsString, toUrlParams} from "./Util";
import {dateColProps} from "../components/AggridHelper";
import cmFormDefs from './formFields/CmLooseDashbordForm';
import editorFormDefs from './formFields/CmLooseDashbordForm';
import pmFormDefs from './formFields/PmLooseleafForm';
import LooseLeafStore from '../stores/LooseLeafStore';
import copy from '../images/copy.png'
import moment from "moment";
import newgenlogo from "../../src/images/newgenlogo.png";

class DashboardBooksStore {
    apiProxy = null;

    constructor() {
        this.apiProxy = appStore.apiProxy;
    }

    @observable activeTab = '0';
    @observable getCountryName = '';

    @observable activeFilter = 'all';
    @observable currentTable = '';
    @observable currentData = {};

    @observable drawerVisible = false;

    @observable rowData = [];
    @observable summaryData = [];

    @observable loading = false;

    @observable selectedApprevation = '';

    @action setLoading = (loading) => {
        this.loading = loading;
    };
    defaultColDef= {
        sortable: true,
        resizable: true,
        filter: true,
      }

    cmColumns = [
        {headerName: "Row", field:'rowno'},
        // {headerName: 'Copy', field:'action', cellRenderer:function () {return '+'}},
        {headerName: 'Publication', field: 'abbreviation'},
        {headerName: 'Country', field: 'publication'},
        // {headerName: 'Publication', field: 'abbreviation', enableRowGroup: true, rowGroup: true, hide: true},
        // {headerName: 'Country', field: 'publication', enableRowGroup: true, rowGroup: true, hide: true},
        // {headerName: 'Stage', field:'stage'},
        {headerName: 'Document Title', field:'classification'},
        {headerName: 'Author', field: 'author'},
        {headerName: 'Last Published', field: 'lastPublishedDate'},
        {headerName: 'Last Updated', field: 'lastUpdated'},
        {headerName: 'Last Supplement', field: 'lastSupplement'},
        {
            headerName: "Author's Last Reminder",
            children: [
        {headerName: 'Reminder', field: 'lastReminder'},
        {headerName: 'Sent On', field: 'lastReminderSent'},
            ]},
        {
            headerName: "Editor's Last Reminder",
            children: [
        {headerName: 'Reminder', field: 'lastGeReminder'},
        {headerName: 'Sent On', field: 'lastGeReminderSent',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {lastGeReminderSent} = data;
            if (!lastGeReminderSent) return '-';
            return moment(lastGeReminderSent).format('YYYY-MM-DD');
        }
        },
            ]},
        {
            headerName: 'Status',
            field: 'status',
          
        },
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectCreatedAt',
             valueGetter: ({data}) => {
                if (!data) return '';
                const {projectCreatedAt} = data;
                if (!projectCreatedAt) return '-';
                return moment(projectCreatedAt).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Request for Update', field: 'requestToAuthor',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {requestToAuthor} = data;
            if (!requestToAuthor) return '-';
            return moment(requestToAuthor).format('YYYY-MM-DD');
        }},
        {headerName: 'Proposed Deadline', field: 'proposedDeadline'},
        {
            headerName: 'Confirmed Deadline',
            field: 'confirmedDeadline',
            
            valueGetter: ({data}) => {
                if (!data) return '';
                const {confirmedDeadline} = data;
                if (!confirmedDeadline) return '-';
                return moment(confirmedDeadline).format('YYYY-MM-DD');
            }
        },
        {
            headerName: 'MS Received',
            field: 'msReceived'
        },
        {headerName: 'Editor Approved', field: 'editorApproved'},
        {headerName: 'CM Approval for Production', field: 'cmApproved'},
        {headerName: 'CM Approval for Content', field: 'cmApprovedForContent'},
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Notes 2', field: 'note1'},
        {headerName: 'Notes 3', field: 'note2'},
        {headerName: 'Author Comments', field: 'comments'},
        {headerName: 'Author Query', field: 'authorQuery'},
        {headerName: 'CTP', field: 'ctp'},
        {headerName: 'PreReview',field: 'preReview'},
        {headerName: 'ReviewType',field: 'reviewType'},
        {headerName: 'NewsAlert',field: 'newsAlert'},
        {
            headerName: 'Others Info',
            children: [
        {
            headerName: 'Files',
            columnGroupShow: 'closed',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived',
                },
            ]},
        {headerName: 'Workflow', field: 'workflow', columnGroupShow: 'open'},
        {headerName: 'Author Email', field: 'authorEmails', columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cm', columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails', columnGroupShow: 'open'},
        {headerName: 'Editor', field: 'editor', columnGroupShow: 'open'},
        {headerName: 'Editor Email', field: 'editorEmails', columnGroupShow: 'open'},
        {headerName: 'Recycle Period', field: 'recyclePeriod', columnGroupShow: 'open'},
        {headerName: 'Category', field: 'category', columnGroupShow: 'open'},
        {headerName: 'Grade', field: 'grade', columnGroupShow: 'open'},
        {headerName: 'Editor Review', field: 'editorReviewDate', columnGroupShow: 'open'},
        {headerName: 'Review Type', field: 'reviewType', columnGroupShow: 'open'},
       
    ]}
        // {headerName: 'Word File To Author', field: 'projectStartDateCopy', ...dateColProps},
     ];
     awaitingColumns = [
        {headerName: "Row", field:'rowno'},
        {headerName: 'Publication', field: 'abbreviation'},
        {headerName: 'Country', field: 'publication'},
        {headerName: 'Document Title', field:'classification'},
        {headerName: 'Author', field: 'author'},
        {headerName: 'Last Published', field: 'lastPublishedDate'},
        {headerName: 'Requested Date', field: 'projectStartDate'},
        {headerName: 'Status', field: 'status'},
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'PreReview',field: 'preReview'},
        {
            headerName: 'Others',
            children: [
        {headerName: 'Last Updated', field: 'lastUpdated',columnGroupShow: 'closed'},
        {headerName: 'Proposed Deadline', field: 'proposedDeadline',columnGroupShow: 'open'},
        {headerName: 'Confirmed Deadline',
            columnGroupShow: 'open',
            field: 'confirmedDeadline',
        
            valueGetter: ({data}) => {
                if (!data) return '';
                const {confirmedDeadline} = data;
                if (!confirmedDeadline) return '-';
                return moment(confirmedDeadline).format('YYYY-MM-DD');
            }
        },
        {
            headerName: 'MS Received',
            columnGroupShow: 'open',
            field: 'msReceived'
        },
        {headerName: 'Editor Approved', field: 'editorApproved',columnGroupShow: 'open'},
        {headerName: 'CM Approval for Production', field: 'cmApproved',columnGroupShow: 'open'},
         {headerName: 'CM Approval for Content', field: 'cmApprovedForContent',columnGroupShow: 'open'},
        {
            headerName: "Author's Last Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'lastReminder'},
        {headerName: 'Sent On', field: 'lastReminderSent'},
            ]},
        {
            headerName: "Editor's Last Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'lastGeReminder'},
        {headerName: 'Sent On', field: 'lastGeReminderSent',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {lastGeReminderSent} = data;
            if (!lastGeReminderSent) return '-';
            return moment(lastGeReminderSent).format('YYYY-MM-DD');
        }
        },
            ]},
        {headerName: 'Notes 2', field: 'note1',columnGroupShow: 'open'},
        {headerName: 'Notes 3', field: 'note2',columnGroupShow: 'open'},
        {headerName: 'Author Comments', field: 'comments',columnGroupShow: 'open'},
        {headerName: 'Author Query', field: 'authorQuery',columnGroupShow: 'open'},
       {headerName: 'CTP', field: 'ctp',columnGroupShow: 'open'},
        {headerName: 'Last Supplement', field: 'lastSupplement',columnGroupShow: 'open'},
        {
            headerName: 'Files',
            columnGroupShow: 'open',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived',
                },
            ]},
       
       {headerName: 'Workflow', field: 'workflow',columnGroupShow: 'open'},
        {headerName: 'Author Email', field: 'authorEmails',columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cm',columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails',columnGroupShow: 'open'},
        {headerName: 'Editor', field: 'editor',columnGroupShow: 'open'},
        {headerName: 'Editor Email', field: 'editorEmails',columnGroupShow: 'open'},
        {headerName: 'Recycle Period', field: 'recyclePeriod',columnGroupShow: 'open'},
       {headerName: 'Category', field: 'category',columnGroupShow: 'open'},
       {headerName: 'Grade', field: 'grade',columnGroupShow: 'open'},
        {headerName: 'Editor Review', field: 'editorReviewDate',columnGroupShow: 'open'},
       {headerName: 'Review Type', field: 'reviewType',columnGroupShow: 'open'},
      
    ]}
        // {headerName: 'Word File To Author', field: 'projectStartDateCopy', ...dateColProps},
     ];
     plannedColumns = [
        {headerName: "Row", field:'rowno'},
        {headerName: 'Publication', field: 'abbreviation'},
        {headerName: 'Country', field: 'publication'},
        {headerName: 'Document Title', field:'classification'},
        {headerName: 'Author', field: 'author'},
        {headerName: 'Last Published', field: 'lastPublishedDate'},
        {headerName: 'Requested Date', field: 'projectStartDate'},
        {headerName: 'Proposed Deadline', field: 'proposedDeadline'},
        {headerName: 'Status', field: 'status'},
        {headerName: 'Notes 1', field: 'notes'},
        {
            headerName: 'Others',
            children: [

       {headerName: 'Last Updated', field: 'lastUpdated',columnGroupShow: 'closed'},
        {
            headerName: 'Confirmed Deadline',
            field: 'confirmedDeadline',
            columnGroupShow: 'open',
            valueGetter: ({data}) => {
                if (!data) return '';
                const {confirmedDeadline} = data;
                if (!confirmedDeadline) return '-';
                return moment(confirmedDeadline).format('YYYY-MM-DD');
            }
        },
        {
            headerName: 'MS Received',
            field: 'msReceived',
            columnGroupShow: 'open'
        },
        {headerName: 'Editor Approved', field: 'editorApproved',columnGroupShow: 'open'},
        {headerName: 'CM Approval for Production', field: 'cmApproved',columnGroupShow: 'open'},
       {headerName: 'CM Approval for Content', field: 'cmApprovedForContent',columnGroupShow: 'open'},
        {
            headerName: "Author's Last Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'lastReminder'},
        {headerName: 'Sent On', field: 'lastReminderSent'},
            ]},
        {
            headerName: "Editor's Last Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'lastGeReminder'},
        {headerName: 'Sent On', field: 'lastGeReminderSent',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {lastGeReminderSent} = data;
            if (!lastGeReminderSent) return '-';
            return moment(lastGeReminderSent).format('YYYY-MM-DD');
        }
        },
            ]},
        {headerName: 'Notes 2', field: 'note1',columnGroupShow: 'open'},
        {headerName: 'Notes 3', field: 'note2',columnGroupShow: 'open'},
        {headerName: 'Author Comments', field: 'comments',columnGroupShow: 'open'},
        {headerName: 'Author Query', field: 'authorQuery',columnGroupShow: 'open'},
        {headerName: 'CTP', field: 'ctp',columnGroupShow: 'open'},
        {headerName: 'Last Supplement', field: 'lastSupplement',columnGroupShow: 'open'},
        {
            headerName: 'Files',
            columnGroupShow: 'open',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived',
                },
            ]},
        {headerName: 'Workflow', field: 'workflow',columnGroupShow: 'open'},
        {headerName: 'Author Email', field: 'authorEmails',columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cm',columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails',columnGroupShow: 'open'},
        {headerName: 'Editor', field: 'editor',columnGroupShow: 'open'},
        {headerName: 'Editor Email', field: 'editorEmails',columnGroupShow: 'open'},
        {headerName: 'Recycle Period', field: 'recyclePeriod',columnGroupShow: 'open'},
       {headerName: 'Category', field: 'category',columnGroupShow: 'open'},
       {headerName: 'Grade', field: 'grade',columnGroupShow: 'open'},
        {headerName: 'Editor Review', field: 'editorReviewDate',columnGroupShow: 'open'},
        {headerName: 'Review Type', field: 'reviewType',columnGroupShow: 'open'},
        {headerName: 'PreReview',field: 'preReview',columnGroupShow: 'open'},
    ]}
        // {headerName: 'Word File To Author', field: 'projectStartDateCopy', ...dateColProps},
     ];
     inColumns = [
        {headerName: "Row", field:'rowno'},
        {headerName: 'Publication', field: 'abbreviation'},
        {headerName: 'Country', field: 'publication'},
        {headerName: 'Document Title', field:'classification'},
        {headerName: 'Author', field: 'author'},
        {headerName: 'Last Published', field: 'lastPublishedDate'},
        {
            headerName: "Author's Last Reminder",
            children: [
        {headerName: 'Reminder', field: 'lastReminder'},
        {headerName: 'Sent On', field: 'lastReminderSent'},
        ]},
        {
            headerName: "Editor's Last Reminder",
            children: [
        {headerName: 'Reminder', field: 'lastGeReminder'},
        {headerName: 'Sent On', field: 'lastGeReminderSent',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {lastGeReminderSent} = data;
            if (!lastGeReminderSent) return '-';
            return moment(lastGeReminderSent).format('YYYY-MM-DD');
        }
        },
        ]},
        {headerName: 'Status', field: 'status'},
        {headerName: 'Planned Date', field: 'projectStartDate'},
        {headerName: 'Project Start Date', field: 'projectCreatedAt',
        valueGetter: ({data}) => {
           if (!data) return '';
           const {projectCreatedAt} = data;
           if (!projectCreatedAt) return '-';
           return moment(projectCreatedAt).format('YYYY-MM-DD');
        }
        },
        {headerName: 'Request for Update', field: 'requestToAuthor',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {requestToAuthor} = data;
            if (!requestToAuthor) return '-';
            return moment(requestToAuthor).format('YYYY-MM-DD');
        }},
        {headerName: 'Proposed Deadline', field: 'proposedDeadline'},
        {
            headerName: 'Confirmed Deadline',
            field: 'confirmedDeadline',
            valueGetter: ({data}) => {
                if (!data) return '';
                const {confirmedDeadline} = data;
                if (!confirmedDeadline) return '-';
                return moment(confirmedDeadline).format('YYYY-MM-DD');
            }
        },
        {
            headerName: 'MS Received',
            field: 'msReceived'
        },
        {
            headerName: 'Files',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived',
                },
            ]},
      
     
        
       
        {headerName: 'Editor Approved', field: 'editorApproved'},
        {headerName: 'CM Approval for Production', field: 'cmApproved'},
        {headerName: 'CM Approval for Content', field: 'cmApprovedForContent'},
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Author Comments', field: 'comments'},
        {
        headerName: 'Others',
        children: [
        {headerName: 'Last Updated', field: 'lastUpdated',columnGroupShow: 'closed'},
        {headerName: 'Author Query', field: 'authorQuery',columnGroupShow: 'open'},
        {headerName: 'CTP', field: 'ctp',columnGroupShow: 'open'},
        {headerName: 'Last Supplement', field: 'lastSupplement',columnGroupShow: 'open'},
         {headerName: 'Notes 2', field: 'note1',columnGroupShow: 'open'},
         {headerName: 'Notes 3', field: 'note2',columnGroupShow: 'open'},
         {headerName: 'Workflow', field: 'workflow',columnGroupShow: 'open'},
        {headerName: 'Author Email', field: 'authorEmails',columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cm',columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails',columnGroupShow: 'open'},
        {headerName: 'Editor', field: 'editor',columnGroupShow: 'open'},
        {headerName: 'Editor Email', field: 'editorEmails',columnGroupShow: 'open'},
        {headerName: 'Recycle Period', field: 'recyclePeriod',columnGroupShow: 'open'},
        {headerName: 'Category', field: 'category',columnGroupShow: 'open'},
        {headerName: 'Grade', field: 'grade',columnGroupShow: 'open'},
        {headerName: 'Editor Review', field: 'editorReviewDate',columnGroupShow: 'open'},
        {headerName: 'Review Type', field: 'reviewType',columnGroupShow: 'open'},
        {headerName: 'PreReview',field: 'preReview',columnGroupShow: 'open'},
        ]}
        // {headerName: 'Word File To Author', field: 'projectStartDateCopy', ...dateColProps},
     ];
     doNotChaseColumns = [
        {headerName: "Row", field:'rowno'},
        {headerName: 'Publication', field: 'abbreviation'},
        {headerName: 'Country', field: 'publication'},
        {headerName: 'Document Title', field:'classification'},
        {headerName: 'Workflow', field: 'workflow'},
        {headerName: 'Last Published', field: 'lastPublishedDate'},
        {headerName: 'Status', field: 'status'},
        {headerName: 'Notes 1', field: 'notes'},
        {headerName: 'Author Comments', field: 'comments'},
        {
            headerName: 'Others',
            children: [
        {headerName: 'Last Updated', field: 'lastUpdated',columnGroupShow: 'closed'},
        {headerName: 'Requested Date', field: 'projectStartDate',columnGroupShow: 'open'},
        {headerName: 'Proposed Deadline', field: 'proposedDeadline',columnGroupShow: 'open'},
        {
            headerName: 'Confirmed Deadline',
            field: 'confirmedDeadline',
            columnGroupShow: 'open',
            valueGetter: ({data}) => {
                if (!data) return '';
                const {confirmedDeadline} = data;
                if (!confirmedDeadline) return '-';
                return moment(confirmedDeadline).format('YYYY-MM-DD');
            }
        },
        {
            headerName: 'MS Received',
            columnGroupShow: 'open',
            field: 'msReceived'
            
        },
        {headerName: 'Editor Approved', field: 'editorApproved',columnGroupShow: 'open'},
        {headerName: 'CM Approval for Production', field: 'cmApproved',columnGroupShow: 'open'},
        {headerName: 'CM Approval for Content', field: 'cmApprovedForContent',columnGroupShow: 'open'},
        {
            headerName: "Author's Last Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'lastReminder'},
        {headerName: 'Sent On', field: 'lastReminderSent'},
            ]},
         {
            headerName: "Editor's Last Reminder",
            columnGroupShow: 'open',
            children: [
        {headerName: 'Reminder', field: 'lastGeReminder'},
        {headerName: 'Sent On', field: 'lastGeReminderSent',
        valueGetter: ({data}) => {
            if (!data) return '';
            const {lastGeReminderSent} = data;
            if (!lastGeReminderSent) return '-';
            return moment(lastGeReminderSent).format('YYYY-MM-DD');
        }
        },
            ]},
        {headerName: 'Notes 2', field: 'note1',columnGroupShow: 'open'},
        {headerName: 'Notes 3', field: 'note2',columnGroupShow: 'open'},
        {headerName: 'Author Query', field: 'authorQuery',columnGroupShow: 'open'},
        {headerName: 'CTP', field: 'ctp',columnGroupShow: 'open'},
        {headerName: 'Last Supplement', field: 'lastSupplement',columnGroupShow: 'open'},
       
        {
            headerName: 'Files',
            columnGroupShow: 'open',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived',
                },
            ]},
        {headerName: 'Author', field: 'author',columnGroupShow: 'open'},
        {headerName: 'Author Email', field: 'authorEmails',columnGroupShow: 'open'},
        {headerName: 'CM', field: 'cm',columnGroupShow: 'open'},
        {headerName: 'CM Email', field: 'cmEmails',columnGroupShow: 'open'},
        {headerName: 'Editor', field: 'editor',columnGroupShow: 'open'},
        {headerName: 'Editor Email', field: 'editorEmails',columnGroupShow: 'open'},
        {headerName: 'Recycle Period', field: 'recyclePeriod',columnGroupShow: 'open'},
        {headerName: 'Category', field: 'category',columnGroupShow: 'open'},
        {headerName: 'Grade', field: 'grade',columnGroupShow: 'open'},
        {headerName: 'Editor Review', field: 'editorReviewDate',columnGroupShow: 'open'},
       {headerName: 'Review Type', field: 'reviewType',columnGroupShow: 'open'},
        {headerName: 'PreReview',field: 'preReview',columnGroupShow: 'open'},
    ]}
        // {headerName: 'Word File To Author', field: 'projectStartDateCopy', ...dateColProps},
     ];
     summaryColumns =[
        {headerName: "Row", field:'rowno'},
         {headerName:'Title', field:'abbreviation'},
        {headerName: 'Total Monograph',field: 'totalMonograph'},
        {headerName: 'Awaiting Acquisition',field: 'awaitingAcquisition'},
        {headerName: 'Planned Acquisition',field: 'plannedAcquisition'},
        {headerName: 'In Acquisition',field: 'inAcquisition'},
        {headerName: 'Do Not Chase',field: 'doNotChase'},
     ];
    editorColumns = [
        {headerName: 'Publication', field: 'abbreviation', pinned: 'left'},
        {headerName: 'Document', field: 'publication', pinned: 'left'},
        {headerName: 'Category', field: 'category'},
        {headerName: 'Author', field: 'author'},
        {headerName: 'Editor', field: 'editor'},
        {headerName: 'CM', field: 'cm'},
        {headerName: 'Editor Review', field: 'editorReviewDate'},
        {headerName: 'Author Query', field: 'authorQuery'},
        {headerName: 'Editor Approved', field: 'editorApproved'},
        {
            headerName: 'Files',
            children: [
                {
                    headerName: 'Sent',
                    field: 'filesSent',
                },
                {
                    headerName: 'Received',
                    field: 'filesReceived'
                },
            ]
        },
        {headerName: 'Status', field: 'status', cellStyle: params => ({color: params.data.statusColor})},
        {headerName: 'Author Comments', field: 'comments'},
    ];

    get columnDefs() {
        if(this.activeFilter=="awaiting")
        {
            return this.awaitingColumns;
        }
        else if(this.activeFilter == "planned")
        {
            return this.plannedColumns;
        }
        else if(this.activeFilter == "in")
        {
            return this.inColumns;
        }
        else if(this.activeFilter == "donotchase")
        {
            return this.doNotChaseColumns;
        }
        else if(this.activeFilter == "all")
        {
            return this.cmColumns;
        }
        else if(this.activeFilter == "SummaryTable")
        {
            return this.summaryColumns;
        }
        // return appStore.credentials.user_type == 'editor'
        //     ? this.editorColumns
        //     : this.cmColumns;
    }
   
    getFormDefs = () => {
        const data = this.currentData;
        const dt =pmFormDefs(data);
        if(data.stage=="In Acquisition")
        {   
            dt[3].disabled = true;
            dt[8].disabled = true;
            dt[9].disabled = true;
            dt[10].disabled = true;
            dt[11].disabled = true;
            dt[12].disabled = true;
            dt[13].disabled = true;
            dt[14].disabled = true;
            dt[15].disabled = true;
            dt[16].disabled = true;
            dt[17].disabled = true;
            dt[18].disabled = true;
            dt[19].disabled = true;
            
        }
        if (appStore.isLooseLeafPm()) return dt;
        //  return appStore.credentials.user_type === 'editor'
        //     ? editorFormDefs(data)
        //     : cmFormDefs(data);
            return appStore.credentials.user_type === 'editor'
            ? editorFormDefs(data)
            : dt;
    };
   
  
    @action nextTab = () => {
        if (this.activeTab == "0") {
            this.activeTab = "1";
        } else if (this.activeTab == "1") {
            this.activeTab = "2";
        } else {
            this.drawerVisible = false;
            this.activeTab = "0";
        }
    };
    @action createItem = async (data)=>{
        let params = {
            ...this.currentData,
            ...data,
        };
        params.country = this.getCountryName;
        params.createdBy = 'CHASER_EMAIL';
        params.projectId = -1;
        params.updatedBy = appStore.credentials.userId;
        const seed = await this.apiProxy.asyncPost(endpoints.createBooksSeedUrl, params);
        this.currentData = await seed.json();
        this.currentData.future_author =this.currentData.authorNames;
        this.currentData.future_authorEmails = this.currentData.authorEmails;
        this.currentData.future_cm = this.currentData.cmNames;
        this.currentData.future_cmEmails = this.currentData.cmEmails;
        this.currentData.future_editor = this.currentData.editorNames;
        this.currentData.future_editorEmails = this.currentData.editorEmails;
        await this.fetchData();
        await this.nextTab();
        this.formLoading = false;
    }

    @action updateItem = async (data) => {
        if(this.currentData.id == undefined)
        {
            this.createItem(data);
            return false;
        }
        let params = {
            ...this.currentData,
            ...data,
        };
        params.country = this.getCountryName;
        params.updatedBy = appStore.credentials.userId;
        if(params.preReview == 'Yes' )
        {
            params.preReview = true;   
        }
        else if(params.preReview == 'No' )
        {
            params.preReview = false;
        }
      /*User can select MIP workflow (not based on p1 and prereview)

        // if(this.selectedApprevation == "MIP")
        // {
        //     if(params.p1Status == false && params.preReview == true)
        //     {
        //         params.globalWorkflowId = 2655;
        //     }
        //     else if(params.p1Status == true && params.preReview == true)
        //     {
        //         params.globalWorkflowId = 3142;
        //     }
        //     else if(params.p1Status == false && params.preReview == false)
        //     {
        //         params.globalWorkflowId = 3132;
        //     }
        //     else if(params.p1Status == true && params.preReview == false)
        //     {
        //         params.globalWorkflowId = 3157;
        //     }
        // }
        */
        try {
            const response = await this.apiProxy.asyncPost(endpoints.updateBooksAttributesUrl, params);
            this.currentData = await params;
            this.currentData.future_author =params.authorNames;
            this.currentData.future_authorEmails = params.authorEmails;
            this.currentData.future_cm = params.cmNames;
            this.currentData.future_cmEmails = params.cmEmails;
            this.currentData.future_editor = params.editorNames;
            this.currentData.future_editorEmails = params.editorEmails;
            
            const data = await response.json();
            this.nextTab();
            this.fixStage(data);
            // this.unfocus();
            // message.success('Loose leaf updated');
            return false;
        } catch (e) {
            message.error('Unable to update data');
            return false;
        }
    };
    @action clickCustomFilter = async (filterValue) =>{
        this.activeFilter = filterValue;
        let tempRowData = [];
            for(let i=0; i<this.currentTable.length; i++)
            {
                if(filterValue == 'in' && this.currentTable[i].stage=='In Acquisition')
                {
                        tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'awaiting' && this.currentTable[i].stage=='Awaiting Acquisition')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'planned' && this.currentTable[i].stage=='Planned Acquisition')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'donotchase' && this.currentTable[i].stage=='Do Not Chase')
                {
                    tempRowData.push(this.currentTable[i]);
                }
                else if(filterValue == 'all')
                {
                    tempRowData.push(this.currentTable[i]);
                }
            }
            
            this.rowData = tempRowData;
           // this.getSummaryData();
     }
     @action getSummaryData = async()=>{
        this.activeFilter = 'SummaryTable';
         let totalMonograph =[];
         let flags = [];
         let summaryRows=[];
        for(let i=0; i<this.currentTable.length; i++) {
            if(flags[this.currentTable[i].abbreviation]) continue;
            flags[this.currentTable[i].abbreviation] = true;
            totalMonograph.push(this.currentTable[i].abbreviation);
        }
     
        
        for(let i=0; i<totalMonograph.length; i++)
        {
           let total = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i])});
           let awaitingAcquisition = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Awaiting Acquisition")});
           let plannedAcquisition = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Planned Acquisition")});
           let inAcquisition = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "In Acquisition")});
           let doNotChase = this.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Do Not Chase")});
           summaryRows.push({
                id:(i),
                rowno:(i+1),
                abbreviation:totalMonograph[i],
                totalMonograph:total.length,
                awaitingAcquisition:awaitingAcquisition.length,
                plannedAcquisition:plannedAcquisition.length,
                inAcquisition:inAcquisition.length,
                doNotChase:doNotChase.length
           })
        }
        this.rowData = summaryRows;
     
    }
     mapToWorkdays=async(date, add)=> {
        const wd = this.weekday(date)
        
        let r = Math.trunc(add / 5) * 2
        const rem = add % 5
      
        if (wd > 4) r += (6-wd)
        else if (wd+rem > 4) r += 2
        
        return add + r;
      }
      weekday=(date)=> { return (date.getUTCDay()+ 6) % 7 }
   
    @action fetchData = async () => {
        this.setLoading(true);
        try {
            const params = {
                userEmail: appStore.credentials.email,
                userType: appStore.credentials.user_type
            };
            const url = endpoints.booksdashboardDataUrl + '?' + toUrlParams(params);
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();
            // console.log("Dashboard");
            // console.log(data);
            
            const mipDates = {"3157":20, "3132":20, "3142":16, "2655":16}
            if(data.status!=500)
            {
                for(let i=0; i<data.length; i++)
                {
                    //for MIP only projectStartDate must be based on workflows
                    //Author Saravanan K
                    //data[i]['projectStartDateCopy'] = data[i]['projectStartDate'];
                    // if(data[i]['abbreviation'] == 'MIP')
                    // {
                    //     if((data[i]['globalWorkflowId']!==undefined) && (mipDates[data[i]['globalWorkflowId']]!==undefined))
                    //     {
                    //         data[i]['projectStartDateCopy'] = moment(data[i]['projectStartDate'], "DD-MM-YYYY").weekday(mipDates[data[i]['globalWorkflowId']], 'days');
                    //     }
                    //     else
                    //     {
                    //         data[i]['projectStartDateCopy'] = moment(data[i]['projectStartDate'], "DD-MM-YYYY").weekday(20, 'days');
                    //     }
                    // }
                    data[i].rowno = (i+1)+' +';
                    // data[i].action = 'Copy';
                    var workflowName = data[i].workflow+"";
                    workflowName = workflowName.toLowerCase();
                    workflowName = workflowName.replace(/ /g,"");
                    workflowName = workflowName.replace(/-/g,"");
                    // console.log(data[i].preReview);
                    // console.log("workflowName");
                    // console.log(workflowName);

                    if(workflowName.match("withprereview"))
                    {
                        data[i].preReview = true;
                    }
                    if(workflowName.match("noprereview"))
                    {
                        data[i].preReview = false;
                    }
                   
                    if(data[i].preReview == true )
                    {
                        data[i].preReview = 'Yes';   
                    }
                    else if(data[i].preReview == false )
                    {
                        data[i].preReview = 'No';
                    }
                    else
                    {
                        data[i].preReview = null;
                    }
                    // console.log("preReview");
                    // console.log(data[i].preReview);
                    
                    if(data[i].projectId > 0 && data[i].holdStatus=='true')
                    {
                        data[i].stage = 'Do Not Chase';
                    }
                    else if(data[i].projectId > 0 && data[i].doNotChase != true)
                    {
                       data[i].stage = 'In Acquisition';
                    }
                    else if(data[i].projectStartDate != null && data[i].projectId == -1 && data[i].doNotChase != true)
                    {
                        data[i].stage = 'Planned Acquisition';
                    }
                    else if(data[i].doNotChase==true)
                    {
                        data[i].stage = 'Do Not Chase';
                    }
                    else
                    {
                       data[i].stage = 'Awaiting Acquisition';
                    }
              
             }   
             
             this.currentTable = data;
             this.clickCustomFilter(this.activeFilter);
            //  this.rowData = data;
            }
          
        } catch (e) {
            message.error('Failed to fetch data');
            console.error(e);
        }
        this.setLoading(false);
    };

    flattenData = async(response) => {
          const rowData = [];
        //   console.log(response);
          Object.keys(response).forEach(publication => {
          const datalist = response[publication];
          datalist.forEach(dt => {
            rowData.push({
              publication: publication,
              projectId: dt.projectId,
              globalWorkflowId: dt.globalWorkflowId,
              abbreviation: dt.abbreviation,
              classification: dt.classification,
              category: dt.category,
              grade: dt.grade,
              author: dt.author,
              editor: dt.editor,
              cm: dt.cm,
              workflow: dt.workflow,
              lastPublishedDate: dt.lastPublishedDate,
              lastUpdated: dt.lastUpdated,
              lastSupplement: dt.lastSupplement,
              ctp: dt.ctp,
              preReview: dt.preReview,
              reviewType: dt.reviewType,
              notes: dt.notes,
              note1: dt.note1,
              note2: dt.note2,
              editorEmails: dt.editorEmails,
              requestDate: dt.requestDate,
              proposedDeadline: dt.proposedDeadline,
              comments: dt.comments,
              confirmedDeadline: dt.confirmedDeadline,
              msReceived: dt.msReceived,
              cmApproved: dt.cmApproved,
              editorApproved: dt.editorApproved,
              editorReviewDate: dt.editorReviewDate,
              lastReminderSent: dt.lastReminderSent,
              lastReminder: dt.lastReminder,
              status: dt.status,
              indicator: dt.indicator,
              filesSent: dt.filesSent,
              filesReceived: dt.filesReceived,
              requestedEndDate: dt.requestedEndDate,
              statusColor: dt.statusColor,
              authorQuery: dt.authorQuery,
              doNotChase: dt.doNotChase,
              p1Status: dt.p1Status,
              projectStartDate: dt.projectStartDate,
              lastUpdatedDate: dt.lastUpdatedDate,
              ifpDate: dt.ifpDate,
              cmpDate: dt.cmpDate,
              filesToAuthorDate: dt.filesToAuthorDate,
              filesFromAuthorDate: dt.filesFromAuthorDate,
              headsUpEmailDate: dt.headsUpEmailDate,
              authorEmails : dt.authorEmails,
              authorNames : dt.authorNames,
              cmEmails : dt.cmEmails,
              cmNames : dt.cmNames,
              editorNames : dt.editorNames,
            });
          });
        });
        
        return rowData;
      };

    @action setCurrentData = (data) => {
        this.currentData = data;
        this.drawerVisible = true;
    };
    @action setCreateData = visible => {
        this.currentData = '';
        this.drawerVisible = visible;
        this.activeTab = '0';
    };
    @action unfocus = () => {
        this.drawerVisible = false;
        this.currentData = {};
    };

    @action deleteLooseLeaf = async(item) => {
        item.deletedBy = appStore.credentials.userId;
        item.deletedAt =  new Date().toISOString().slice(0, 19).replace('T', ' ');
        const response = await this.apiProxy.asyncPost(endpoints.updateBooksAttributesUrl, item);
        const data = await response.json();
        this.fixStage(data);
    }
    @action fixStage = (data) =>{
        if(data.status!=500)
        {
            for(let i=0; i<data.length; i++)
            {
                data[i].rowno = (i+1)+' +';
                // data[i].action = 'Copy';
                var workflowName = data[i].workflow+"";
                workflowName = workflowName.toLowerCase();
                workflowName = workflowName.replace(/ /g,"");
                workflowName = workflowName.replace(/-/g,"");
                if(workflowName.match("withprereview"))
                {
                    data[i].preReview = true;
                }
                if(workflowName.match("noprereview"))
                {
                    data[i].preReview = false;
                }
                if(data[i].preReview == true )
                {
                    data[i].preReview = 'Yes';   
                }
                else if(data[i].preReview == false )
                {
                    data[i].preReview = 'No';
                }
                else
                {
                    data[i].preReview = null;
                }
                if(data[i].projectId > 0 && data[i].holdStatus=='true')
                {
                    data[i].stage = 'Do Not Chase';
                }
                else if(data[i].projectId > 0 && data[i].doNotChase != true)
                {
                   data[i].stage = 'In Acquisition';
                }
                else if(data[i].projectStartDate != null && data[i].projectId == -1 && data[i].doNotChase != true)
                {
                    data[i].stage = 'Planned Acquisition';
                }
                else if(data[i].doNotChase==true)
                {
                    data[i].stage = 'Do Not Chase';
                }
                else
                {
                   data[i].stage = 'Awaiting Acquisition';
                }
            }   
            this.currentTable = data;
            this.clickCustomFilter(this.activeFilter);
            // this.rowData = data;
        }
        else
        {
            message.error('Failed to fetch data');
            console.error(e);
        }

       
    }
}

export default new DashboardBooksStore();